module.exports = __webpack_public_path__ + "img/doorbell.49db5a76.svg";